import { render } from "./mapAssessorInstituteDrawer.vue?vue&type=template&id=33fe11b8&ts=true"
import script from "./mapAssessorInstituteDrawer.vue?vue&type=script&lang=ts"
export * from "./mapAssessorInstituteDrawer.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__